import React from "react";
import './Event.css';

import { extractDateParts } from "../../utils";

import { Link } from "react-router-dom";



const Event = ({ session }) => {

    const { weekday, day, shortMonth } = extractDateParts(session.details.date); // Extracting formatted date parts using utility function

    return (

        <div className="event-item">

            <img src={session.image} alt={session.title} /> {/* Session Image */}

            <div className="content">

                <div className="date">{weekday} <br /> <span>{day}</span> {shortMonth}</div> {/* Session Date */}

                <div className="text">

                    <h5>{session.details.time}</h5> {/* Session Timing */}

                    {/* Link to the individual session page */}
                    <Link
                        to={{
                            pathname: '/Schedule/' + session.title,  // Navigate to the specific session page
                        }}
                        location = {{session}}  // Passing session details to the linked page
                        className="main-heading"
                        state= {session}> 
                        {session.title} {/* Session Title */}
                    </Link>

                    <h3>{session.details.venue}</h3> {/* Session Venue */}

                </div>
            </div>

        </div>
    );
};

export default Event;